import { Dialog } from '@mui/material';
import { IconX, IconAlertCircleFilled } from '@tabler/icons-react';
import PropTypes from 'prop-types';
import { Button, IconButton } from 'ui';

const ConfirmDeleteModal = ({ data, onClose, onDelete, loading, description }) => {
  const handleDelete = () => {
    onDelete(data?.id);
  };

  const handleClose = () => {
    if (loading) return;
    onClose();
  };

  return (
    <Dialog
      maxWidth="xs"
      open={!!data}
      onClose={handleClose}
      sx={{ '.MuiPaper-root': { padding: 0, margin: 0, borderRadius: '12px', width: '100%' } }}
    >
      <div className="space-y-6 p-6">
        <div className="relative flex">
          <div className="flex items-center space-x-3">
            <IconAlertCircleFilled size={20} className="text-red-500" />
            <h3 className="text-h6 font-semibold">Delete {data?.entity}?</h3>
          </div>

          <IconButton
            Icon={<IconX size={20} className="text-gray-400" />}
            srOnly="Close"
            onClick={handleClose}
            color="transparent"
            className="absolute -right-1 -top-1 !p-1"
            disabled={loading}
          />
        </div>

        <p className="text-base">
          Are you sure you want to delete the &quot;{data?.name}&quot; {data?.entity}?
        </p>

        {description && <p className="text-base text-gray-600">{description}</p>}

        <div className="flex justify-end space-x-3">
          <Button title="No, cancel" onClick={handleClose} disabled={loading} />

          <Button
            title={loading ? 'Loading...' : "Yes, I'm sure"}
            color="destructive"
            disabled={loading}
            onClick={handleDelete}
            loading={loading}
          />
        </div>
      </div>
    </Dialog>
  );
};

ConfirmDeleteModal.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    entity: PropTypes.string.isRequired,
  }),
  onClose: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  description: PropTypes.node,
};

ConfirmDeleteModal.defaultProps = {
  loading: false,
  description: null,
};

export default ConfirmDeleteModal;
